import Lottie from "lottie-react";
import loadingAnimation from "@/assets/loading.lottie.json";
import { cn } from "./utils";

interface LoadingProps {
  className?: string;
  size?: number;
}

function Loading({ className, size = 32 }: LoadingProps) {
  return (
    <div
      data-slot="loading"
      className={cn("flex items-center justify-center", className)}
    >
      <Lottie
        animationData={loadingAnimation}
        loop
        autoplay
        style={{ width: size, height: size }}
      />
    </div>
  );
}

export { Loading };
